import { OverlayModule } from '@angular/cdk/overlay';
import { TitleCasePipe } from '@angular/common';
import { Component, computed, input, OnDestroy } from '@angular/core';
import { FadeInOut } from '../../../../animations/fade-in-out.animation';
import { BeTooltipComponent } from '../../../shared/components/be-tooltip/be-tooltip.component';
import { IconApprovalThumbComponent } from '../../../shared/components/icon-approval-thumb/icon-approval-thumb.component';
import { IconInfoOutlineComponent } from '../../../shared/components/icon-info-outline/icon-info-outline.component';

export type ApprovalChanceVariation = 'default' | 'hero';

@Component({
  selector: 'app-approval-chance',
  imports: [
    OverlayModule,
    TitleCasePipe,
    BeTooltipComponent,
    IconApprovalThumbComponent,
    IconInfoOutlineComponent,
  ],
  templateUrl: './approval-chance.component.html',
  styleUrls: ['./approval-chance.component.scss'],
  animations: [FadeInOut(200, 150)],
})
export class ApprovalChanceComponent implements OnDestroy {
  approval = input.required<string>();
  disclosure = input<string>();
  direction = input<string>('up');
  alignment = input<string>('');
  readonly variation = input<ApprovalChanceVariation>('default');
  readonly thumbIconWidth = computed(() => (this.variation() === 'hero' ? '16' : '12'));
  readonly thumbIconHeight = computed(() => (this.variation() === 'hero' ? '16' : '12'));
  readonly thumbIconMarginClass = computed(() =>
    this.variation() === 'hero' ? 'mr-2' : 'mr-1'
  );
  readonly infoIconWidth = computed(() => (this.variation() === 'hero' ? '14' : '12'));
  readonly infoIconHeight = computed(() => (this.variation() === 'hero' ? '14' : '12'));
  isShowTooltipFocused = false;
  isShowTooltipHovered = false;
  private hoverTimeout?: ReturnType<typeof setTimeout>;
  private readonly HOVER_DELAY_MS = 200;

  get isTooltipOpen(): boolean {
    return this.isShowTooltipFocused || this.isShowTooltipHovered;
  }

  setIsShowTooltipFocused(value: boolean) {
    this.isShowTooltipFocused = value;
  }

  setIsShowTooltipHovered(value: boolean): void {
    this.clearHoverTimeout();

    if (value) {
      this.isShowTooltipHovered = true;
      return;
    }


    if (!this.isShowTooltipFocused) {
      this.hoverTimeout = setTimeout(() => {
        this.isShowTooltipHovered = false;
      }, this.HOVER_DELAY_MS);
    }
  }

  clearHoverTimeout(): void {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = undefined;
    }
  }

  ngOnDestroy(): void {
    this.clearHoverTimeout();
  }
}
